var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBookmarkedList = function SvgIconBookmarkedList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.946 15.931a.618.618 0 0 1-.642-.045.641.641 0 0 1-.304-.563V1.352C0 .992.135.676.406.406.676.136.99 0 1.352 0h9.915c.36 0 .676.135.946.406.27.27.406.585.406.946v13.97c0 .24-.102.429-.305.564a.618.618 0 0 1-.642.045L6.31 13.633.946 15.93Z",
    fill: "#8F8F9B"
  })));
};
export default SvgIconBookmarkedList;